export default "__VITE_ASSET__DVFEwQ9z__"